<section>
  <div class="row mb-2">
    <div class="col-12 container-style d-flex justify-content-end">
      <app-custom-button [title]="'Nuevo Registro'" [label]="'Nuevo'" [severity]="'success'" [variant]="undefined"
        [icon]="'pi pi-plus'" [width]="'5.5rem'" (onClick)="createNewRegister()">
      </app-custom-button>
    </div>
  </div>
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formInventoryPeriod">
      <div class="row p-2">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="inventoryPeriodContract.userNameCreate"
                [createDate]="inventoryPeriodContract.createDate"
                [userNameUpdate]="inventoryPeriodContract.userNameUpdate"
                [updateDate]="inventoryPeriodContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-2 col-sm-2 col-12">
              <app-custom-input-number formControlName="year" [labelText]="'Año'"
                [required]="true"></app-custom-input-number>
            </div>
            <div class="col-lg-3 col-md-2 col-sm-2 col-12">
              <app-custom-input-number formControlName="period" [labelText]="'Período'"
                [required]="true"></app-custom-input-number>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-2 col-12 d-flex align-items-end mt-1">
              <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined" (onClick)="send()">
              </app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="row mt-2">
    <div class="col-12 d-flex justify-content-end">
      <app-custom-button [title]="'Salir'" [severity]="'danger'" [label]="'Salir'" (onClick)="close()">
      </app-custom-button>
    </div>
  </div>
</section>